export default {
  mixed: {
    required: 'This field is required',
    default: 'Invalid field'
  },
  string: {
    min: ({ min }) => `This field must be at least ${min} characters`,
    max: ({ max }) => `This field must be at most ${max} characters`,
    email: 'Please enter a valid email address'
  },
  number: {
    min: ({ min }) => `This field must be at least ${min}`,
    max: ({ max }) => `This field must be at most ${max}`
  }
}
